export enum BuildingDepartmentMode {
    Add,
    Update,
    ReadOnly
}